import React from 'react';
import './Privacy.css';
const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1 className="privacy-policy-title">Privacy Policy</h1>

      <section className="privacy-policy-section">
        <h2 className="privacy-policy-heading">1. Data Collection</h2>
        <p>
          The only information we collect and store is your email address, which is required solely for the registration
          process on our platform. We do not request or store any other type of personal data.
        </p>
      </section>

      <section className="privacy-policy-section">
        <h2 className="privacy-policy-heading">2. Use of Email Address</h2>
        <p>
          The email address is used exclusively for registration on CoinStatsHub.tech. We do not send notifications,
          newsletters, or any other communications to the user.
        </p>
      </section>

      <section className="privacy-policy-section">
        <h2 className="privacy-policy-heading">3. Email Security</h2>
        <p>
          Although we only store the email address, we implement security measures to protect this information against
          unauthorized access.
        </p>
      </section>

      <section className="privacy-policy-section">
        <h2 className="privacy-policy-heading">4. Policy Modifications</h2>
        <p>
          CoinStatsHub.tech reserves the right to update this Privacy Policy at any time. Any changes will be notified on
          the platform.
        </p>
      </section>

      <p className="privacy-policy-footer">
        By using CoinStatsHub.tech, you accept this Privacy Policy and acknowledge that we only store your email address
        for registration purposes without any additional communication.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
